import { LegalClientActivity } from 'api/types/entity';
import { getYesOrNoOptions } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { YesOrNoType } from 'types/yesOrNo';

import { Field, useFormContext } from '../../../forms/companyActivityForm';

import { FieldLabelWithHint } from './components';

export interface FormContentProps {}

export const FormContent = () => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  const isOtherActivity = values.activity?.value === LegalClientActivity.Other;

  return (
    <Stack spacing={24} spacingMobile={16}>
      <Field.Autocomplete
        label={t('onboarding.companyActivity.activity.label')}
        name="activity"
        optionLabelKey="label"
        options={Object.values(LegalClientActivity).map((v) => ({
          label: t(`onboarding.companyActivity.activity.types.${v}`),
          value: v,
        }))}
        optionValueKey="value"
        placeholder={t('onboarding.companyActivity.activity.placeholder')}
        variant="select"
      />

      {isOtherActivity && (
        <Field.Text
          label={t('onboarding.companyActivity.otherActivity.label')}
          name="otherActivity"
          placeholder={t(
            'onboarding.companyActivity.otherActivity.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={
          <FieldLabelWithHint
            hintTexts={t(
              'onboarding.companyActivity.isLargeEnterprise.hintTexts',
              {
                returnObjects: true,
              }
            )}
            hintTitle={t(
              'onboarding.companyActivity.isLargeEnterprise.hintTitle'
            )}
            label={t('onboarding.companyActivity.isLargeEnterprise.label')}
          />
        }
        name="isLargeEnterprise"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t('onboarding.companyActivity.isNominalHolder.label')}
        name="isNominalHolder"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      {values.isNominalHolder?.value === YesOrNoType.Yes && (
        <Field.Autocomplete
          label={t(
            'onboarding.companyActivity.requiresNominalHoldingSubaccount.label'
          )}
          name="requiresNominalHoldingSubaccount"
          optionLabelKey="label"
          options={getYesOrNoOptions(t)}
          optionValueKey="value"
          placeholder={t('common.select.placeholder')}
          variant="select"
        />
      )}
    </Stack>
  );
};
